import { render, staticRenderFns } from "./analysisManagementCenter.vue?vue&type=template&id=15b96f70&scoped=true"
import script from "./analysisManagementCenter.vue?vue&type=script&lang=js"
export * from "./analysisManagementCenter.vue?vue&type=script&lang=js"
import style0 from "./analysisManagementCenter.vue?vue&type=style&index=0&id=15b96f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b96f70",
  null
  
)

export default component.exports